// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__5SPQx","actions":"style_actions__vlePE","actions_btn":"style_actions_btn__mqDeX"};